export const ChevronDownIcon = ({ color = 'currentColor', width = 20, height = 20 }: { color?: string; width?: number; height?: number }) => (
  <svg width={width} height={height} viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M5 7.5L10 12.5L15 7.5'
      stroke={color}
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
